import { render, staticRenderFns } from "./CardEventList.vue?vue&type=template&id=bd670528&"
import script from "./CardEventList.vue?vue&type=script&lang=js&"
export * from "./CardEventList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports